const state = {
    screenLeaveFlg: false,
};
const getters = {
    getScreenLeaveFlg(state) {
      return state.screenLeaveFlg;
    },
};
const mutations = {
    screenLeaveFlg(state, info) {
      state.screenLeaveFlg = info;
    },
};
const actions = {
    setScreenLeaveFlg(context, info) {
      context.commit('screenLeaveFlg', info);
    },
};
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};